import { gql } from '@efficiently/client-core-graphql-models';

export const SET_FINISHID = gql(`
	mutation ProjectLocationSetFinishId($finishes: [String!]!, $finishId: String) {
		setFinishId(finishes: $finishes, finishId: $finishId) {
			...FinishDomainFinishFields
		}
	}
`);

export const SET_FINISHID_WITH_CASCADE = gql(`
	mutation SetFinishIdWithCascade($finishes: [String!]!, $finishId: String) {
		setFinishIdWithCascade(finishes: $finishes, finishId: $finishId) {
			finishes {
				...FinishDomainFinishFields
			}
			cascade {
				finishIds {
					_id
					status
				}
				finishes {
					_id
					status
				}
			}
		}
	}
`);
